// Cookie consent building blocks: stored preference shape, storage keys, theme tokens,
// the gtag consent bridge, the custom switch, and the category copy.

export interface CookiePreferences {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
}

export const COOKIE_CONSENT_KEY = '7sigma_cookie_consent';
export const COOKIE_PREFERENCES_KEY = '7sigma_cookie_preferences';

export const ink = 'var(--ink, #0a0a0b)';
export const paper = 'var(--paper, #fafafa)';

export function applyPreferences(prefs: CookiePreferences) {
  if (!window.gtag) return;
  window.gtag('consent', 'update', {
    analytics_storage: prefs.analytics ? 'granted' : 'denied',
    ad_storage: prefs.marketing ? 'granted' : 'denied',
    ad_user_data: prefs.marketing ? 'granted' : 'denied',
    ad_personalization: prefs.marketing ? 'granted' : 'denied',
  });
}

export function Switch({
  checked,
  disabled,
  onChange,
  label,
}: {
  checked: boolean;
  disabled?: boolean;
  onChange?: (v: boolean) => void;
  label: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange?.(!checked)}
      className="relative h-6 w-11 shrink-0 rounded-full transition-colors duration-200 disabled:cursor-not-allowed"
      style={{
        backgroundColor: checked ? '#2563eb' : 'transparent',
        boxShadow: checked
          ? 'none'
          : `inset 0 0 0 1.5px color-mix(in srgb, ${ink} 35%, transparent)`,
        opacity: disabled ? 0.6 : 1,
      }}
    >
      <span
        className="absolute top-1 h-4 w-4 rounded-full transition-transform duration-200"
        style={{
          left: 4,
          transform: checked ? 'translateX(20px)' : 'translateX(0)',
          backgroundColor: checked ? '#ffffff' : ink,
        }}
      />
    </button>
  );
}

export const categories: {
  key: keyof CookiePreferences;
  title: string;
  body: string;
  locked?: boolean;
}[] = [
  {
    key: 'necessary',
    title: 'Essential',
    body: 'Keeps the site working. Always on.',
    locked: true,
  },
  { key: 'analytics', title: 'Analytics', body: 'Anonymous usage so 7Sigma can improve the site.' },
  { key: 'marketing', title: 'Marketing', body: 'Measures whether outreach reached you.' },
];
